<template>
  <div class="space-y-2">
    <div v-for="(value, key) in data" :key="key" class="text-sm">
      <span class="font-medium text-gray-600">{{ formatKey(key) }}:</span>
      <template v-if="typeof value === 'object' && value !== null">
        <RichListDisplay v-if="Array.isArray(value)" :items="value" class="ml-4" />
        <RichObjectDisplay v-else :data="value" class="ml-4" />
      </template>
      <template v-else>
        <span class="text-gray-700 ml-1">{{ value }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import RichListDisplay from './RichListDisplay.vue'; // Import for arrays within objects

export default {
  name: 'RichObjectDisplay',
  components: {
    RichListDisplay
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    formatKey(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  }
};
</script>

<style scoped>
/* Add any specific styling if needed */
</style> 